export { VoiceCard } from "./VoiceCard";
export type { VoiceCardProps, VoiceCardVariant } from "./VoiceCard";
